import type { BoxProps } from '@hover/blueprint';
import { Button } from '@hover/blueprint';
import type { MutableRefObject } from 'react';
import React, { useEffect, useRef } from 'react';

import { List } from '../List';

interface PillListProps extends Omit<BoxProps, 'onClick'> {
  enableScrollIntoView?: boolean;
  expandHeader?: React.ReactNode;
  expandButton?: React.ReactNode;
  header: string | React.ReactNode;
  items: string[];
  selected?: string;
  subHeader?: React.ReactNode;
  onClick: (id: string) => void;
  wrapItems?: boolean;
}

const PillList = ({
  onClick,
  selected,
  header,
  enableScrollIntoView = false,
  items,
  ...props
}: PillListProps) => {
  const selectedRef: MutableRefObject<HTMLButtonElement | null> = useRef(null);
  useEffect(() => {
    if (enableScrollIntoView) {
      selectedRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }
  });
  return (
    <List header={header} {...props}>
      {items.map(item => (
        <Button
          fill={selected === item ? 'solid' : 'outline'}
          key={item}
          marginBottom={200}
          marginRight={200}
          onClick={() => onClick(item)}
          ref={selected === item ? selectedRef : undefined}
        >
          {item}
        </Button>
      ))}
    </List>
  );
};

export { PillList };
